import Image from 'next/image'

interface Props {
  title: string
  description: string
  image: StrapiImageFile
}

const TopTalent = ({ title, description, image }: Props) => {
  return (
    <section>
      <div className="container flex flex-wrap lg:flex-nowrap gap-7 md:gap-12 justify-between | pb-8 md:pb-20">
        <div className="max-w-col-6 mx-auto">
          <h2
            className="text-2xl md:text-3xl font-medium | my-4 md:my-11"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <span
            className="text-lg md:text-2xl"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        {image ? (
          <Image
            src={image.url}
            alt={image.alternativeText ?? ''}
            width={image.width}
            height={image.height}
            className="mx-auto"
          />
        ) : null}
      </div>
    </section>
  )
}

export default TopTalent
